import Player from './Player';
import TransactionInfo from './TransactionInfo';

type FloatingCardProps = {
  isSticky: boolean;
};

const FloatingCard: React.FC<FloatingCardProps> = ({ isSticky }) => {
  return (
    <div
      id="sticky-card"
      className="tw-overflow-hidden tw-bg-neutral-light-100 tw-pointer-events-auto tw-z-5 md:tw-mt-2.4 tw-rounded-2 tw-shadow-02"
      data-cy="transaction-buttons-section"
    >
      <Player isSticky={isSticky} />
      <TransactionInfo className="tw-hidden md:tw-block" />
    </div>
  );
};

export default FloatingCard;
